import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgOtpInputConfig } from 'ng-otp-input';

@Component({
  templateUrl: './modal-nip.component.html',
  styleUrls: ['./modal-nip.component.scss']
})
export class ModalNipComponent {

  otpInputConfig: NgOtpInputConfig = {
    length: 4,
    disableAutoFocus: false,
    isPasswordInput: true
  };

  constructor(private modal: MatDialogRef<ModalNipComponent, string>) { }

  checkNip(nip: string) {
    if (nip.length === this.otpInputConfig.length) {
      this.modal.close(nip);
    }
  }

  close() {
    this.modal.close();
  }

}
